import { all, call, put, takeLatest } from "redux-saga/effects";
import {handleResponse, httpDelete, httpGet, httpPost, httpPostAsync, httpPut} from "../../utils/HttpClient";
import {
  SET_SERVER_MESSAGE,
  UPDATE_APPLICATION_FINANCE_QUOTES,
  UpdateFinanceQuotesAction,
  updateFinanceQuotesSuccess,
  LoadJdPowersportHistoryAction,
  loadJdPowersportHistorySuccess,
  LOAD_JDPOWERSPORT_HISTORY,
  CreateIncomeAction,
  createIncomeSuccess,
  CREATE_INCOME,
  UPDATE_INCOME,
  UpdateIncomeAction,
  DeleteIncomeAction,
  deleteIncomeSuccess,
  DELETE_INCOME,
  updateIncomeSuccess,
  LOAD_EMAIL_NOTIFICATIONS,
  LoadEmailNotificationsAction,
  loadEmailNotificationsSuccess,
  SendCustomerReferencesToAmsAction,
  SEND_CUSTOMER_REFERENCES_TO_AMS,
  sendCustomerReferencesToAmsSuccess,
  SET_LOADING,
  CreateOrganizationAction,
  createOrganizationSuccess,
  CREATE_ORGANIZATION,
  CREATE_ORGANIZATION_SUCCESS,
  UpdateOrganizationAction,
  updateOrganizationSuccess,
  UPDATE_ORGANIZATION,
  UPDATE_ORGANIZATION_SUCCESS,
  LOAD_MANAGEMENT_ORGANIZATIONS,
  loadManagementOrganizations,
  loadManagementOrganizationsSuccess,
  GetPreviousAmsLoansAction,
  getPreviousAmsLoansSuccess,
  GET_PREVIOUS_AMS_LOANS,
  LoadReleaseNotesAction,
  LoadCurrentReleaseNotesAction,
  loadCurrentReleaseNotesSuccess,
  loadReleaseNotesSuccess,
  LOAD_RELEASE_NOTES,
  LOAD_CURRENT_RELEASE_NOTES,
  CreateCustomerReferenceAction,
  createCustomerReferenceSuccess,
  CREATE_CUSTOMER_REFERENCE,
  UpdateCustomerReferenceAction,
  updateCustomerReferenceSuccess,
  UPDATE_CUSTOMER_REFERENCE,
  DeleteCustomerReferenceAction,
  deleteCustomerReferenceSuccess,
  updateCustomerReferenceVerificationSuccess,
  UPDATE_CUSTOMER_REFERENCE_VERIFICATION,
  DELETE_CUSTOMER_REFERENCE,
  UpdateCustomerReferenceVerification,
  LoadApplicationQueueCountsAction,
  loadApplicationQueueCountsSuccess,
  LOAD_APPLICATION_QUEUE_COUNTS,
  LoadEmployeeApplicationHistoriesAction,
  LOAD_EMPLOYEE_APPLICATION_HISTORIES,
  loadEmployeeApplicationHistoriesSuccess,
  CreateEmployeeApplicationHistoryAction,
  createEmployeeApplicationHistorySuccess,
  CREATE_EMPLOYEE_APPLICATION_HISTORY,
  createApplicationDownPaymentRequestSuccess,
  createApplicationDownPaymentRequestFailure,
  CreateApplicationDownPaymentRequestAction,
  CREATE_APPLICATION_DOWN_PAYMENT_REQUEST,
  GetCarletonAprForApplicationFundingAction,
  getCarletonAprForApplicationFundingSuccess,
  GET_CARLETON_APR_FOR_APPLICATION_FUNDING,
  LoadGlobalSearchItemsAction,
  loadGlobalSearchPageSuccess,
  LOAD_GLOBAL_SEARCH_ITEMS,
  setIsLoadingGlobalSearchPage,
  getDownPaymentHistoriesSuccess,
  GetDownPaymentHistoriesAction,
  GET_DOWN_PAYMENT_HISTORIES,
  GetNewSignedUrlAction,
  GET_NEW_SIGNED_URL,
  getNewSignedUrlSuccess,
  GetSignedUrlsAction,
  GET_SIGNED_URLS,
  getSignedUrlsSuccess,
  getDownPaymentHistories, 
  VoidDownPaymentAction,
  voidDownPaymentSuccess,
  VOID_DOWN_PAYMENT,
  CreateCashDealApplicationAction,
  createCashDealApplicationSuccess,
  CREATE_CASH_DEAL_APPLICATION,
} from "./types";
import { IJdPowersportHistoryItems } from "../../Components/Views/OrderEditor/JdPowersportHistory";
import { updateFinanceQuoteCalcErrorsSuccess } from "../Notifications/actions";
import { watchSolveLeaseQuoteSaga } from "./leaseQuoteSaga";
import { IEmailNotificationItems } from "../../Components/Views/OrderEditor/EmailNotifications";
import { ICustomerReference } from "../../Interfaces/Customer/ICustomerReference";
import { IAmsPreviousLoanData } from "../../Interfaces/Common/IAmsPreviousLoanData";
import {
  ApplicationDownPaymentRequest, ApplicationDownPaymentResponse,
  hasValue,
  Organization,
  PerformanceIndicatorEvaluationResult,
  ReleaseNotes
} from "@amsanalytics/react-shared-library";
import { GET_APPLICATION_PERFORMANCE_EVALUATION, GET_PERFORMANCE_EVALUATION, GetApplicationPerformanceEvaluationAction, GetPerformanceEvaluationAction, getApplicationPerformanceEvaluationSuccess, getPerformanceEvaluationSuccess } from "./actions";
import { ApplicationPerformanceIndicatorEvaluationResult } from "@amsanalytics/react-shared-library";
import localforage from "localforage";
import { authService } from '../../index';
import { displayError } from "../../utils/utils";
import { refreshAllDownPaymentCardCharges } from "../../Data/DownPaymentCardData";
import {IApplicationQueueCountsResult} from "../../Interfaces/Common/IApplicationQueue";
import {IEmployeeApplicationHistory} from "../../Interfaces/Common/IEmployeeApplicationHistory";
import {ApplicationFunding} from "../../Interfaces/Application/ApplicationFunding";
import { GlobalSearchPage } from "../../Data/GlobalSearchPage";
import {paymentProcessors} from "../../utils/constants";
import {CarletonCalculationResult} from "../../Interfaces/Application/CarletonCalculationResult";

const toTwoDigits = (value: number): string => value < 10 ? `0${value}` : `${value}`;

const toLocalDateTimeString = (value: Date | string | null | undefined): string | null => {
  if (!value) {
    return null;
  }

  const dateValue = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dateValue.getTime())) {
    return null;
  }

  return `${dateValue.getFullYear()}-${toTwoDigits(dateValue.getMonth() + 1)}-${toTwoDigits(dateValue.getDate())}T${toTwoDigits(dateValue.getHours())}:${toTwoDigits(dateValue.getMinutes())}:${toTwoDigits(dateValue.getSeconds())}`;
};

const prepareOrganizationPayload = (organization: Organization): Organization => ({
  ...organization,
  businessHours: (organization.businessHours || []).map(businessHour => ({
    ...businessHour,
    startTime: toLocalDateTimeString(businessHour.startTime) as any,
    endTime: toLocalDateTimeString(businessHour.endTime) as any,
  })),
});

function* loadJdPowersportHistorySaga(action: LoadJdPowersportHistoryAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/jdpower/getJdPowersportHistory/${action.payload.applicationId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
    } else {
      const histories: IJdPowersportHistoryItems[] = yield call([response, response.json]);
      yield put(loadJdPowersportHistorySuccess(histories));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}
export function* watchLoadJdPowersportHistorySaga() {
  yield takeLatest(LOAD_JDPOWERSPORT_HISTORY, loadJdPowersportHistorySaga);
}

function* loadEmailNotificationsSaga(action: LoadEmailNotificationsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/emailApplicationActivity/${action.payload.applicationId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
    } else {
      const emailNotificationItems: IEmailNotificationItems[] = yield call([response, response.json]);
      yield put(loadEmailNotificationsSuccess(emailNotificationItems));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}
export function* watchLoadEmailNotificationsSaga() {
  yield takeLatest(LOAD_EMAIL_NOTIFICATIONS, loadEmailNotificationsSaga);
}

function* updateFinanceQuotesSaga(action: UpdateFinanceQuotesAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/applicationFinanceQuote/CarletonQuoteCalc`,
      action.payload.application,
      token
    );
    if (!response.ok) {
      const error: any = yield call([response, response.json]);
      const errorMessage = typeof error === 'string' ? error : (error?.Message ?? error?.message ?? JSON.stringify(error));
      yield (put(displayMessage(errorMessage, true)));
    } else {
      const carletonCalculationResult: CarletonCalculationResult = yield call([response, response.json]);

      if (carletonCalculationResult.errors.length > 0) {
        yield put(updateFinanceQuoteCalcErrorsSuccess(carletonCalculationResult.errors));
      } else {
        yield put(updateFinanceQuotesSuccess(carletonCalculationResult, action.payload.newVehicle));
      }
    }
  } catch (error: any) {
    const errorMessage = typeof error === 'string' ? error : (error?.message ?? JSON.stringify(error));
    yield put(displayMessage(errorMessage, true));
  }
  yield put(setApplicationLoading(false));
}
export function* watchUpdateFinanceQuoteSaga() {
  yield takeLatest(UPDATE_APPLICATION_FINANCE_QUOTES, updateFinanceQuotesSaga);
}

// Create Income
export function* createIncomeSaga(action: CreateIncomeAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPut,
      `api/income`,
      action.payload.income,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
    } else {
      // pluck out the id from the response
      const { id } = yield call([response, response.json]);
      yield put(createIncomeSuccess(
        {
          id,
          incomeTypeId: action.payload.income.incomeTypeId,
          createdDate: action.payload.income.createdDate,
          amount: action.payload.income.amount,
          comments: action.payload.income.comments,
          startDate: action.payload.income.startDate,
          endDate: action.payload.income.endDate,
        },
        action.payload.income.ownerId
      ));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchCreateIncomeSaga() {
  yield takeLatest(CREATE_INCOME, createIncomeSaga);
}

// Update Income
export function* updateIncomeSaga(action: UpdateIncomeAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/income`,
      action.payload.income,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
    } else {
      yield put(updateIncomeSuccess(action.payload.income, action.payload.ownerId));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchUpdateIncomeSaga() {
  yield takeLatest(UPDATE_INCOME, updateIncomeSaga);
}

// Delete Income
export function* deleteIncomeSaga(action: DeleteIncomeAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpDelete,
      `api/income/${action.payload.incomeId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
    } else {
      yield put(deleteIncomeSuccess(action.payload.incomeId, action.payload.ownerId));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchDeleteIncomeSaga() {
  yield takeLatest(DELETE_INCOME, deleteIncomeSaga);
}

// Sending Customer References to AMS
export function* sendCustomerReferencesToAmsSaga(action: SendCustomerReferencesToAmsAction) {
  try {
    yield put(setApplicationLoading(true));
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/ams/SendCustomerReferencesToAms`,
      action.payload.customerReferences,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield put(setApplicationLoading(false));
      yield put(displayMessage(error, true));
    } else {
      const updatedCustomerReferences: ICustomerReference[] = yield call([response, response.json]);
      yield put(sendCustomerReferencesToAmsSuccess(updatedCustomerReferences));
      yield put(setApplicationLoading(false));
      yield put(displayMessage("Customer Reference Sent to Ams", false));
    }
  } catch (error) {
    yield put(setApplicationLoading(false));
    yield put(displayMessage(error as string, true));
  }
}
export function* watchSendCustomerReferencesToAmsSaga() {
  yield takeLatest(SEND_CUSTOMER_REFERENCES_TO_AMS, sendCustomerReferencesToAmsSaga);
}

/** Create Organization */
function* createOrganizationSaga(action: CreateOrganizationAction) {
  try {
    const token: string = yield authService.getToken();
    const payload = prepareOrganizationPayload(action.payload);
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/Organization/create`,
      payload,
      token
    );
    if (response && response.ok) {
      const createdOrg = yield call(handleResponse, response);
      // Prefer the server-returned org (it carries the assigned id + server-enforced fields such as the
      // immutable AmsCode); fall back to the request payload only if the API returned no body. Strip the
      // response-only amsSyncWarning so the reducer keeps a clean domain object and surface it separately.
      const { amsSyncWarning, ...savedOrg } = createdOrg ?? {};
      yield put(createOrganizationSuccess(createdOrg ? savedOrg : action.payload));
      // Partial success: saved locally but AMS sync failed — surface it as a warning (the row still
      // reloads) instead of hiding it behind a failure.
      if (amsSyncWarning) {
        yield put(displayMessage(amsSyncWarning, true));
      }
    } else {
      // Surface the server's specific error (e.g. "AMS code already exists"). handleResponse throws
      // Error(message) for a { message } body; fall back to a generic message if it can't be parsed.
      let errorMessage = "Could not create this organization.";
      try {
        yield call(handleResponse, response);
      } catch (handleResponseError) {
        errorMessage = (handleResponseError as Error)?.message || errorMessage;
      }
      yield put(displayMessage(errorMessage, true));
    }

  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}
export function* watchCreateOrganization() {
  yield takeLatest(CREATE_ORGANIZATION, createOrganizationSaga);
}
/** END Add Organization */

/** Update Organization */
function* updateOrganizationSaga(action: UpdateOrganizationAction) {
  try {
    const token: string = yield authService.getToken();
    const payload = prepareOrganizationPayload(action.payload);
    const response: { json: any, ok: boolean, status: number } = yield call(httpPut,
      `api/Organization/update`,
      payload,
      token
    );
    if (response && response.ok) {
      const updatedOrg = yield call(handleResponse, response);
      // Prefer the server-returned org (it carries server-enforced fields such as the immutable AmsCode);
      // fall back to the request payload only if the API returned no body. Strip the response-only
      // amsSyncWarning so the reducer keeps a clean domain object and surface it separately.
      const { amsSyncWarning, ...savedOrg } = updatedOrg ?? {};
      yield put(updateOrganizationSuccess(updatedOrg ? savedOrg : action.payload));
      // Partial success: saved locally but AMS sync failed — surface it as a warning (the row still
      // reloads) instead of hiding it behind a failure.
      if (amsSyncWarning) {
        yield put(displayMessage(amsSyncWarning, true));
      }
    } else {
      // Surface the server's specific error (e.g. a duplicate AMS code). handleResponse throws
      // Error(message) for a { message } body; fall back to a generic message if unparseable.
      let errorMessage = "Could not update this organization.";
      try {
        yield call(handleResponse, response);
      } catch (handleResponseError) {
        errorMessage = (handleResponseError as Error)?.message || errorMessage;
      }
      yield put(displayMessage(errorMessage, true));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}
export function* watchUpdateOrganization() {
  yield takeLatest(UPDATE_ORGANIZATION, updateOrganizationSaga);
}
/** END update Organization */

/** Load management organizations (org-management page list — INCLUDES StorageLot) */
function* loadManagementOrganizationsSaga() {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/Organization/forManagement`,
      token
    );
    // handleResponse returns the parsed body on success and throws on non-ok (400/500), so a failed load
    // surfaces an error instead of silently leaving the page empty/stale. Mirrors CRM/AppCenter.
    const organizations: Organization[] = yield call(handleResponse, response);
    yield put(loadManagementOrganizationsSuccess(organizations));
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}
export function* watchLoadManagementOrganizations() {
  yield takeLatest(LOAD_MANAGEMENT_ORGANIZATIONS, loadManagementOrganizationsSaga);
}

// After a create/update succeeds, re-fetch the management list so it reflects server truth (server-assigned
// id, full enrichment, post-transition type) — never optimistically spliced (the LOS create payload is id-less).
function* reloadManagementOrganizationsSaga() {
  yield put(loadManagementOrganizations());
}
export function* watchReloadManagementOrganizationsOnMutation() {
  yield takeLatest([CREATE_ORGANIZATION_SUCCESS, UPDATE_ORGANIZATION_SUCCESS], reloadManagementOrganizationsSaga);
}
/** END management organizations */

function* getPreviousAmsLoansSaga(action: GetPreviousAmsLoansAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/ams/GetPreviousLoansFromAms/?applicationId=${action.payload.applicationId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
    } else {
      const previousAmsLoans: IAmsPreviousLoanData[] = yield call([response, response.json]);
      yield put(getPreviousAmsLoansSuccess(previousAmsLoans));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}
export function* watchGetPreviousAmsLoansSaga() {
  yield takeLatest(GET_PREVIOUS_AMS_LOANS, getPreviousAmsLoansSaga);
}

function* getDownPaymentHistoriesFromAmsSaga(action: GetDownPaymentHistoriesAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/ams/GetDownPaymentResponsesFromAms/?applicationId=${action.payload.applicationId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
    } else {
      const downPaymentHistories: ApplicationDownPaymentResponse[] = yield call([response, response.json]);
      yield put(getDownPaymentHistoriesSuccess(downPaymentHistories));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}
export function* watchGetDownPaymentHistoriesFromAmsSaga() {
  yield takeLatest(GET_DOWN_PAYMENT_HISTORIES, getDownPaymentHistoriesFromAmsSaga);
}

function* loadReleaseNotesSaga(action: LoadReleaseNotesAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet, `api/releaseNotes`, token);
    const releaseNotes: ReleaseNotes[] = yield call([response, response.json]);
    yield put(loadReleaseNotesSuccess(releaseNotes));
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchLoadReleaseNotes() {
  yield takeLatest(LOAD_RELEASE_NOTES, loadReleaseNotesSaga);
}

function* loadCurrentReleaseNotesSaga(action: LoadCurrentReleaseNotesAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet, `api/releaseNotes/current`, token);
    const releaseNotes: ReleaseNotes[] = yield call([response, response.json]);
    yield put(loadCurrentReleaseNotesSuccess(releaseNotes));
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchLoadCurrentReleaseNotes() {
  yield takeLatest(LOAD_CURRENT_RELEASE_NOTES, loadCurrentReleaseNotesSaga);
}

export function* getPerformanceEvaluationSaga(action: GetPerformanceEvaluationAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpPost,
      `api/scoring/PerformanceItemEvaluations`,
      action.payload.performanceEvaluationRequest,
      token
    );
    const performanceIndicatorResults: PerformanceIndicatorEvaluationResult[] = yield call([response, response.json]) as any;
    yield put(getPerformanceEvaluationSuccess(performanceIndicatorResults));
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchGetPerformanceEvaluation() {
  yield takeLatest(GET_PERFORMANCE_EVALUATION, getPerformanceEvaluationSaga);
}


export function* getApplicationPerformanceEvaluationSaga(action: GetApplicationPerformanceEvaluationAction) {
  try {
    const token: string = yield authService.getToken();
    const indicatorsToUseInScoring = yield localforage.getItem('scoringIndicators');
    const response: { json: any } = yield call(httpPost,
      `api/scoring/ApplicationPerformanceItemEvaluations`,
      {
        ...action.payload.applicationPerformanceRequest,
        indicatorsToUseInScoring: indicatorsToUseInScoring ?? []
      },
      token
    );
    const performanceIndicatorResults: ApplicationPerformanceIndicatorEvaluationResult[] = yield call([response, response.json]) as any;
    yield put(getApplicationPerformanceEvaluationSuccess(action.payload.applicationPerformanceRequest.applicationId, performanceIndicatorResults));
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchGetApplicationPerformanceEvaluation() {
  yield takeLatest(GET_APPLICATION_PERFORMANCE_EVALUATION, getApplicationPerformanceEvaluationSaga);
}

// customer references

// Create Customer References
export function* createCustomerReferenceSaga(action: CreateCustomerReferenceAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpPost, `api/reference`,
      { ...action.payload.customerReference, id: null, customerId: action.payload.customerId },
      token
    );
    const customerReference: ICustomerReference = yield call([response, response.json]) as any;
    yield put(createCustomerReferenceSuccess(action.payload.customerId, { ...customerReference, createdBy: action.payload.createdByName, createdDate: new Date() }));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchCreateCustomerReference() {
  yield takeLatest(CREATE_CUSTOMER_REFERENCE, createCustomerReferenceSaga);
}

// Update Customer Reference
export function* updateCustomerReferenceSaga(action: UpdateCustomerReferenceAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpPut, `api/reference`,
      action.payload.customerReference,
      token
    );
    if (response.status === 200) {
      yield put(updateCustomerReferenceSuccess(action.payload.customerReference));
    } else {
      yield put(displayError(response.error ?? `An error occurred while updating the customer reference: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchUpdateCustomerReference() {
  yield takeLatest(UPDATE_CUSTOMER_REFERENCE, updateCustomerReferenceSaga);
}

// Delete Customer Reference
export function* deleteCustomerReferenceSaga(action: DeleteCustomerReferenceAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpDelete, `api/reference/${action.payload.customerReferenceId}`,
      token
    );
    if (response.status === 200) {
      yield put(deleteCustomerReferenceSuccess(action.payload.customerReferenceId));
    } else {
      yield put(displayError(response.error ?? `An error occurred while deleting the customer reference: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchDeleteCustomerReference() {
  yield takeLatest(DELETE_CUSTOMER_REFERENCE, deleteCustomerReferenceSaga);
}

// update customer reference verification
export function* updateCustomerReferenceVerificationSaga(action: UpdateCustomerReferenceVerification) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpPost, `api/reference/verify`,
      { customerReferenceId: action.payload.customerReferenceId, isVerified: action.payload.isVerified },
      token
    );
    if (response.status === 200) {
      yield put(updateCustomerReferenceVerificationSuccess(action.payload.customerReferenceId, action.payload.isVerified, action.payload.modifiedByName));
    } else {
      yield put(displayError(response.error ?? `An error occurred while verifying the customer reference: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchUpdateCustomerReferenceVerification() {
  yield takeLatest(UPDATE_CUSTOMER_REFERENCE_VERIFICATION, updateCustomerReferenceVerificationSaga);
}

// update customer reference verification
export function* loadApplicationQueueCountsSaga(action: LoadApplicationQueueCountsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpPost, "api/Application/ApplicationQueuesCount",
      action.payload,
      token
    );
    if (response.status === 200) {
      const results: IApplicationQueueCountsResult[] = yield call([response, response.json]) as any;
      yield put(loadApplicationQueueCountsSuccess(results));
    } else {
      yield put(displayError(response.error ?? `An error occurred while getting queue count: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchLoadApplicationQueueCount() {
  yield takeLatest(LOAD_APPLICATION_QUEUE_COUNTS, loadApplicationQueueCountsSaga);
}

// Creates the EmployeeApplicationHistory record
export function* createEmployeeApplicationHistorySaga(action: CreateEmployeeApplicationHistoryAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpPost, `api/Employee/employeeApplicationHistory?applicationId=${action.payload.applicationId}`,
      {},
      token
    );
    if (response.status === 200) {
      yield put(createEmployeeApplicationHistorySuccess(action.payload));
    } else {
      yield put(displayError(response.error ?? `An error occurred while getting employee application histories: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchCreateEmployeeApplicationHistorySaga() {
  yield takeLatest(CREATE_EMPLOYEE_APPLICATION_HISTORY, createEmployeeApplicationHistorySaga);
}

// Gets the most recently viewed applications for this Employee
export function* loadEmployeeApplicationHistoriesSaga(action: LoadEmployeeApplicationHistoriesAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpGet, `api/Employee/employeeApplicationHistories?count=${action.payload}`,
      token
    );
    if (response.status === 200) {
      const results: IEmployeeApplicationHistory[] = yield call([response, response.json]) as any;
      yield put(loadEmployeeApplicationHistoriesSuccess(results));
    } else {
      yield put(displayError(response.error ?? `An error occurred while getting employee application histories: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchLoadEmployeeApplicationHistories() {
  yield takeLatest(LOAD_EMPLOYEE_APPLICATION_HISTORIES, loadEmployeeApplicationHistoriesSaga);
}

// Creates the ApplicationDownPaymentRequest record
export function* createApplicationDownPaymentRequestSaga(action: CreateApplicationDownPaymentRequestAction) {
  yield put(setApplicationLoading(true));
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpPost, `api/DownPayment/MakePayment`,
      action.payload.applicationDownPaymentRequest,
      token
    );
    if (response.status === 200) {
      const result: ApplicationDownPaymentRequest = yield call([response, response.json]) as any;
      yield put(createApplicationDownPaymentRequestSuccess(result));
      if (action.payload?.paymentProcessorId.toLowerCase() === paymentProcessors.ams.toLowerCase()) {
        // Shows a success message if the payment went to AMS and it was successful
        // If the payment is for AMS, we don't know when the payment is actually processed because it's in the iframe
        yield put(displayMessage("Payment posted to AMS successfully.", false));
      }
      else if (hasValue(result.url)) {
        yield put(displayMessage("Payment link created successfully.", false));
      }
      else {
        yield put(displayMessage("Payment request created successfully, but no payment link was generated.", false));
      }
      
      // Refreshing the down payment histories just in case there's an update
      yield put(getDownPaymentHistories(action.payload.applicationDownPaymentRequest.applicationId));
    } else {
      let errorMessage = `An error occurred while creating the payment request (HTTP ${response.status}).`;
      try {
        const errorBody: { error?: string; message?: string } = yield call([response, response.json]);
        if (errorBody?.error) {
          errorMessage = errorBody.error;
        } else if (errorBody?.message) {
          errorMessage = errorBody.message;
        }
      } catch {
        // Response body wasn't JSON — use the default message
      }
      yield put(createApplicationDownPaymentRequestFailure(errorMessage));
    }
  } catch (error) {
    yield put(createApplicationDownPaymentRequestFailure(error as string));
  }
  yield put(setApplicationLoading(false));
}

export function* watchCreateApplicationDownPaymentRequestSaga() {
  yield takeLatest(CREATE_APPLICATION_DOWN_PAYMENT_REQUEST, createApplicationDownPaymentRequestSaga);
}

// Gets the Carleton calculated APR to compare to the disclosure
export function* getCarletonAprForApplicationFundingSaga(action: GetCarletonAprForApplicationFundingAction) {
  yield put(setApplicationLoading(true));
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(httpPost, 'api/Carleton/CarletonAprCalc',
      action.payload,
      token
    );
    if (response.status === 200) {
      const result: ApplicationFunding = yield call([response, response.json]) as any;
      yield put(getCarletonAprForApplicationFundingSuccess(result));
    } else {
      yield put(displayError(response.error ?? `An error occurred while getting Carleton APR for Application Funding: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
  yield put(setApplicationLoading(false));
}

export function* watchGetCarletonAprForApplicationFundingSaga() {
  yield takeLatest(GET_CARLETON_APR_FOR_APPLICATION_FUNDING, getCarletonAprForApplicationFundingSaga);
}

// global search
export function* globallySearchApplicationsSaga(action: LoadGlobalSearchItemsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPostAsync,
      `api/application/globalSearch`,
      action.payload,
      token
    );
    if (!response.ok) {
      // destruct the error message from the response
      const { error } = yield call([response, response.json]);
      yield (put(displayMessage(error, true)));
      yield put(setIsLoadingGlobalSearchPage(false));
    } else {
      const globaSearchPage: GlobalSearchPage = yield call([response, response.json]);
      yield put(loadGlobalSearchPageSuccess(globaSearchPage));
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchGloballySearchApplicationsSaga() {
  yield takeLatest(LOAD_GLOBAL_SEARCH_ITEMS, globallySearchApplicationsSaga);
}

// Gets a forced-refresh signed URL for a single 700Credit iframe
export function* getNew700CreditSignedUrlSaga(action: GetNewSignedUrlAction) {
  yield put(setApplicationLoading(true));
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(
      httpGet, 
      `api/CreditApp/signedUrl?applicationId=${action.payload.applicationId}&customerCreditId=${action.payload.customerCreditId}`,
      token
    );
    if (response.status === 200) {
      const result: string = yield call([response, response.json]) as any;
      yield put(getNewSignedUrlSuccess(action.payload.customerCreditId.toLowerCase(), result));
    } else {
      yield put(displayError(response.error ?? `An error occurred while getting a new 700Credit Signed URL: ${response.error}`));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
  yield put(setApplicationLoading(false));
}

export function* watchGetNew700CreditSignedUrlSaga() {
  yield takeLatest(GET_NEW_SIGNED_URL, getNew700CreditSignedUrlSaga);
}

// Gets signed URLs for all applicants on the application (uses cached if still valid)
export function* getSignedUrlsSaga(action: GetSignedUrlsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(
      httpGet,
      `api/CreditApp/signedUrls?applicationId=${action.payload.applicationId}`,
      token
    );
    if (response.status === 200) {
      const dtos: { customerCreditId: string, signedIframeUrl: string }[] = yield call([response, response.json]) as any;
      const signedUrls: Record<string, string> = {};
      dtos.forEach(dto => { signedUrls[dto.customerCreditId.toLowerCase()] = dto.signedIframeUrl; });
      yield put(getSignedUrlsSuccess(signedUrls));
    }
  } catch (error) {
    // Silent fail — signed URLs are non-critical for page load
  }
}

export function* watchGetSignedUrlsSaga() {
  yield takeLatest(GET_SIGNED_URLS, getSignedUrlsSaga);
}

export function* voidDownPaymentSaga(action: VoidDownPaymentAction) {
  yield put(setApplicationLoading(true))
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(
      httpPut,
      `api/DownPayment/VoidPayment?&applicationDownPaymentResponseId=${action.payload.applicationDownPaymentResponseIdToVoid}`,
      {},
      token
    );
    if (response.status === 200) {
      yield put(voidDownPaymentSuccess(action.payload.applicationDownPaymentResponseIdToVoid));
      // A card deposit's void says what happened to the card (LOS card down payments A14); a non-card one answers no
      // message. Its card row moved, so the application's card rows are read again.
      let voidResult: { message?: string | null } | null = null;
      try {
        voidResult = yield call([response, response.json]);
      } catch {
        voidResult = null;
      }
      if (voidResult?.message) {
        yield put(displayMessage(voidResult.message, false));
        yield call(refreshAllDownPaymentCardCharges);
      }
    } else {
      const errorBody: any = yield call([response, response.json]);
      const errorMessage = errorBody?.exceptionMessage ?? errorBody?.message ?? 'An error occurred while voiding the payment.';
      yield put(displayError(errorMessage));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
  yield put(setApplicationLoading(false));
}

export function* watchVoidDownPaymentSaga() {
  yield takeLatest(VOID_DOWN_PAYMENT, voidDownPaymentSaga);
}

// Create Cash Deal Application
export function* createCashDealApplicationSaga(action: CreateCashDealApplicationAction) {
  yield put(setApplicationLoading(true));
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, status: number, error: string } = yield call(
      httpPost,
      'api/Application/createCashDealApplication',
      action.payload,
      token
    );
    if (response.status === 200) {
      const result: { applicationId: string } = yield call([response, response.json]) as any;
      yield put(createCashDealApplicationSuccess(result.applicationId));
    } else {
      yield put(displayError(response.error ?? 'An error occurred while creating cash deal application'));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
  yield put(setApplicationLoading(false));
}

export function* watchCreateCashDealApplicationSaga() {
  yield takeLatest(CREATE_CASH_DEAL_APPLICATION, createCashDealApplicationSaga);
}

export default function* financeQuoteSagas() {
  yield all([
    watchUpdateFinanceQuoteSaga(),
    watchSolveLeaseQuoteSaga(),
    watchLoadJdPowersportHistorySaga(),
    watchCreateIncomeSaga(),
    watchUpdateIncomeSaga(),
    watchDeleteIncomeSaga(),
    watchLoadEmailNotificationsSaga(),
    watchSendCustomerReferencesToAmsSaga(),
    watchCreateOrganization(),
    watchUpdateOrganization(),
    watchLoadManagementOrganizations(),
    watchReloadManagementOrganizationsOnMutation(),
    watchGetPreviousAmsLoansSaga(),
    watchGetDownPaymentHistoriesFromAmsSaga(),
    watchLoadReleaseNotes(),
    watchLoadCurrentReleaseNotes(),
    watchGetPerformanceEvaluation(),
    watchGetApplicationPerformanceEvaluation(),
    watchCreateCustomerReference(),
    watchUpdateCustomerReference(),
    watchDeleteCustomerReference(),
    watchUpdateCustomerReferenceVerification(),
    watchLoadApplicationQueueCount(),
    watchCreateEmployeeApplicationHistorySaga(),
    watchLoadEmployeeApplicationHistories(),
    watchCreateApplicationDownPaymentRequestSaga(),
    watchGetCarletonAprForApplicationFundingSaga(),
    watchGloballySearchApplicationsSaga(),
    watchGetNew700CreditSignedUrlSaga(),
    watchGetSignedUrlsSaga(),
    watchVoidDownPaymentSaga(),
    watchCreateCashDealApplicationSaga(),
    watchUnlockApplicationSectionsSaga(),
    watchFetchActiveUnlockSaga(),
    watchRelockApplicationSaga()
  ])
}

// ─── Application Unlock Sagas ───────────────────────────────────────────

function* unlockApplicationSectionsSaga(action: any) {
  try {
    const token: string = yield authService.getToken();
    const { applicationId, sections, reason } = action.payload;
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/Application/${applicationId}/unlock`,
      { applicationId, sections, reason },
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield put(displayMessage(typeof error === 'string' ? error : (error as any)?.message || 'Failed to unlock application', true));
    } else {
      const unlockLog: any = yield call([response, response.json]);
      yield put({ type: 'UNLOCK_APPLICATION_SECTIONS_SUCCESS', payload: unlockLog });
    }
  } catch (error) {
    yield put(displayMessage(error as string, true));
  }
}

export function* watchUnlockApplicationSectionsSaga() {
  yield takeLatest('UNLOCK_APPLICATION_SECTIONS', unlockApplicationSectionsSaga);
}

function* fetchActiveUnlockSaga(action: any) {
  try {
    const token: string = yield authService.getToken();
    const { applicationId } = action.payload;
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/Application/${applicationId}/unlock/active`,
      token
    );
    if (response.ok) {
      const unlockLog: any = yield call([response, response.json]);
      yield put({ type: 'FETCH_ACTIVE_UNLOCK_SUCCESS', payload: unlockLog });
    }
  } catch (error) {
    // Silent failure — active unlock is optional
  }
}

export function* watchFetchActiveUnlockSaga() {
  yield takeLatest('FETCH_ACTIVE_UNLOCK', fetchActiveUnlockSaga);
}

function* relockApplicationSaga(action: any) {
  try {
    const token: string = yield authService.getToken();
    const { applicationId } = action.payload;
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/Application/${applicationId}/relock`,
      {},
      token
    );
    if (response.ok) {
      yield put({ type: 'RELOCK_APPLICATION_SUCCESS' });
    }
  } catch (error) {
    // Silent failure
  }
}

export function* watchRelockApplicationSaga() {
  yield takeLatest('RELOCK_APPLICATION', relockApplicationSaga);
}

const displayMessage = (message: string, isError: boolean) => {
  return { type: SET_SERVER_MESSAGE, payload: { message: message, isError: isError } };
}

const setApplicationLoading = (isLoading: boolean) => {
  return { type: SET_LOADING, payload: isLoading };
}
